'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$61() {
  this.bk8 = null;
  this.bk9 = false;
}
export { $c_Lpresto_PrestoRouter$$anon$61 as $c_Lpresto_PrestoRouter$$anon$61 };
$p = $c_Lpresto_PrestoRouter$$anon$61.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$61;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$61() {
}
export { $h_Lpresto_PrestoRouter$$anon$61 as $h_Lpresto_PrestoRouter$$anon$61 };
$h_Lpresto_PrestoRouter$$anon$61.prototype = $p;
$p.P = (function() {
  if ((!this.bk9)) {
    this.bk8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T1($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.bk9 = true;
  }
  return this.bk8;
});
var $d_Lpresto_PrestoRouter$$anon$61 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$61, "presto.PrestoRouter$$anon$61", ({
  OD: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$61 as $d_Lpresto_PrestoRouter$$anon$61 };
//# sourceMappingURL=presto.-Presto-Router$$anon$61.js.map
